/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { SupportedStatusRequest, SupportedStatusResponse } from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class MerchantSupportStatusController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags merchant-support-status-controller
   * @name GetSupported
   * @request POST:/api/v1/document-fetcher/merchants/supported
   */
  getSupported = (data: SupportedStatusRequest, params: RequestParams = {}) =>
    this.http.request<SupportedStatusResponse, any>({
      path: `/v1/document-fetcher/merchants/supported`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getSupportedPath = '/v1/document-fetcher/merchants/supported'
  static getSupportedMethod = 'POST'
}
